import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/feedback',
    name: 'feedback',
    component: () => import('@/sub-app/feedback/pages/feedback'),
    meta: {
      title: '我要反馈',
    },
  },
  {
    path: '/feedback/detail',
    name: 'feedbackDetail',
    component: () => import('@/sub-app/feedback/pages/feedbackDetail'),
    meta: {
      title: '反馈详情',
    },
  },
  {
    path: '/feedback/history',
    name: 'feedbackHistory',
    component: () => import('@/sub-app/feedback/pages/feedbackHistory'),
    meta: {
      title: '反馈历史'
    }
  },
  {
    path: '/feedback/successfulPage',
    name: 'successfulPage',
    component: () => import('@/sub-app/feedback/pages/successfulPage'),
    meta: {
      title: '提交成功'
    }
  },
  {
    path: '/',
    redirect: '/feedback',
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  // 设置webview标题
  document.title = to.meta?.title || '';
  next();
});

export default router;
